// This is a modal for Profileinfoone

import { Button as AIMEButton } from "tot-loft-component-library";

import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

export default function ModalProfileinfoone({ onClose }) {
  const navigate = useNavigate();
  return (
    <RootWrapperModalProfileinfoone>
      <Overlay>
        <Wrapper>
          <PopupMessages>
            <Left>
              <Frame1391>
                <ThumbsUp21 />
                <ReferralSubmittedSuccessfully>
                  Update Request sent
                </ReferralSubmittedSuccessfully>
                <ReferralSubmittedSuccessfullyYouLlBeNotifiedWhenThereSAnUpdate>
                  An information change successfully submitted. You’ll be
                  notified when there’s an update.
                </ReferralSubmittedSuccessfullyYouLlBeNotifiedWhenThereSAnUpdate>
                <Frame1400>
                  <AIMEButton
                    size="small"
                    onClick={() => navigate("/")}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "251px",
                      background: "rgb(33, 37, 67)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                      "&:hover": {
                        background: "rgb(33, 37, 67)",
                        opacity: "0.9",
                      },
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "center",
                      }}
                    >
                      Go to Dashboard
                    </span>
                  </AIMEButton>
                </Frame1400>
              </Frame1391>
            </Left>
          </PopupMessages>
        </Wrapper>
      </Overlay>
    </RootWrapperModalProfileinfoone>
  );
}

const RootWrapperModalProfileinfoone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;


const PopupMessages = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
  padding: 24px 0px;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ThumbsUp21 = styled.div`
  width: 174px;
  height: 174px;
  background: url("https://d3nakrlcog1u3z.cloudfront.net/1750247491834-23d53e5dd2068dd3957af942812ce7c59bf82008 (1).png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const ReferralSubmittedSuccessfully = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const ReferralSubmittedSuccessfullyYouLlBeNotifiedWhenThereSAnUpdate = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1400 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
`;
